const ActivitiesSection = () => {
    return (
        <section className="basic-area activities-area">
            <div className="container">
                <div className="basic-flex activities">
                    <img
                        className="basic-flex__image"
                        src="/images/activity.gif"
                        alt="activities"
                    />

                    <div className="basic-flex__content">
                        <h2>
                            Create responsive and easy surveys in
                            minutes.
                        </h2>
                        <div>
                            With predefined survey templates and question banks, you can create surveys in minutes.
                        </div>
                        <br></br>
                        <img style={{border: "5px solid #808080ff", borderRadius: "4px", width: "600px", height: "300px", alignSelf: "center"}}
                        className="basic-flex__image"
                        src="/images/portalCreateActivity.png"
                        alt="activities"
                    />
                    </div>
                       

                </div>
            </div>
        </section>
    );
};

export default ActivitiesSection;
